import type { SanityProjectDetails } from '@sanity/image-url';
import { createImageUrlBuilder } from '@sanity/image-url';
import { createContext, useContext } from 'react';

export type { SanityProjectDetails };
export const SanityProjectDetailsContext = createContext<SanityProjectDetails>({ projectId: '', dataset: '' });

export function useSanityProjectDetailsContext() {
    return useContext(SanityProjectDetailsContext);
}

export function useImageUrlBuilder(projectDetails?: SanityProjectDetails) {
    return createImageUrlBuilder(projectDetails ?? useContext(SanityProjectDetailsContext));
}
